// src/services/authservice.js
import api from "./api";

// Matches auth.py -> /login
export const loginService = async (email, password) => {
  try {
    const response = await api.post("/auth/login", { email, password });
    
    // Backend returns APIResponse { success: true, data: { token, refresh_token, user: { ... } } }
    const authData = response.data?.data || response.data;
    const token = authData?.token || authData?.access_token;
    const user = authData?.user;
    const refreshToken = authData?.refresh_token;

    if (token) {
      if (user) {
        localStorage.setItem("user", JSON.stringify(user));
      }
      localStorage.setItem("token", token);
      if (refreshToken) {
        localStorage.setItem("refresh_token", refreshToken);
      }
    }
    return authData;
  } catch (error) {
    throw error.response ? error.response.data : new Error("Server Error");
  }
};

// Matches public.py -> /signup
export const signupService = async (userData) => {
  try {
    // userData should contain: name, email, password, phone_number, role
    const response = await api.post("/public/signup", userData);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error("Signup Failed");
  }
};

// Matches auth.py -> /logout (server-side token revocation)
export const logoutService = async () => {
  try {
    await api.post("/auth/logout");
  } catch {
    // Proceed with local cleanup even if server call fails
  } finally {
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    localStorage.removeItem("refresh_token");
  }
};

// Matches auth.py -> /refresh
export const refreshTokenService = async () => {
  const refreshToken = localStorage.getItem("refresh_token");
  if (!refreshToken) throw new Error("No refresh token");
  const response = await api.post("/auth/refresh", null, {
    headers: { Authorization: `Bearer ${refreshToken}` },
  });
  const newToken = response.data?.data?.access_token || response.data?.access_token;
  if (newToken) {
    localStorage.setItem("token", newToken);
  }
  return newToken;
};